﻿//Jquery
import "./jquery-global.js";
import $ from "jquery";
import {getFadedMapOptions} from "./support/faded-map-options";

let isInitialized = false;

function setLocation(location) {
    const form = $("[data-choose-branch-form]");
    form.find('input[name="Latitude"]').val(location.lat());
    form.find('input[name="Longitude"]').val(location.lng());
    setTimeout(() => {
        $("[data-choose-branch-form]").get(0).submit();
    }, 50);
}

function handlePlaceSelected(autoComplete) {
    let place = autoComplete.getPlace();

    if (!place.geometry) {
        return;
    }

    let location = place.geometry.location;
    if (location) {
        setLocation(location);
    }
}

export function initializeChooseBranchMap() {
    if (!isInitialized && document.getElementById("choose-branch-map")) {
        isInitialized = true;
        let chooseBranchMap = $("#choose-branch-map");
        let defaultMapLocation = {
            lat: chooseBranchMap.data("lat"), lng: chooseBranchMap.data("lng")
        };
        new google.maps.Map(chooseBranchMap[0], getFadedMapOptions(defaultMapLocation));

        let locationSelect = document.getElementById('chooseLocationSearchInput');

        if (locationSelect) {
            const chooseBranchAutocomplete = new google.maps.places.Autocomplete(locationSelect, {
                types: ['geocode'], componentRestrictions: {country: ['gb', 'im', 'gg', 'je', 'ie']}
            });
            chooseBranchAutocomplete.addListener('place_changed', () => handlePlaceSelected(chooseBranchAutocomplete));
            locationSelect.addEventListener('keydown', function (e) {
                if (e.key === "Enter") {
                    e.preventDefault();
                    if (this.value.trim().length > 0) {
                        getFirstPrediction(this.value, locationSelect);
                    }
                }
            });
        }

    }
}

function getFirstPrediction(inputValue, locationSelect) {
    const service = new google.maps.places.AutocompleteService({
        types: ['geocode'], componentRestrictions: {country: ["gb"]}
    });
    service.getQueryPredictions({input: inputValue + ', UK'}, function (predictions, status) {
        if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
            return;
        }

        locationSelect.value = predictions[0].description;
        let googlePlacesService = new google.maps.places.PlacesService(document.createElement('span'));
        googlePlacesService.getDetails({
            reference: predictions[0].reference
        }, function (details, status) {
            if (details) {
                let location = details.geometry.location;
                if (location) {
                    setLocation(location);
                }
            }
        });
    });
}
